import { Link } from "react-router-dom";

function AdminDashboard() {

  return (
    <div className="container mt-4">

      <h3>Admin Dashboard</h3>

      <div className="row mt-4">

        <div className="col-md-4">
          <div className="card p-4 text-center">
            <h5>Users</h5>
            <Link to="/admin/users" className="btn btn-primary">Open</Link>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card p-4 text-center">
            <h5>Products</h5>
            <Link to="/admin/products" className="btn btn-success">Open</Link>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card p-4 text-center">
            <h5>Orders</h5>
            <Link to="/admin/orders" className="btn btn-warning">Open</Link>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card p-4 text-center">
            <h5>Driver</h5>
            <Link to="/admin/add-driver" className="btn btn-danger">Driver</Link>
          </div>
        </div>

      </div>

    </div>
  );
}

export default AdminDashboard;
